import { render, staticRenderFns } from "./NewBusinessContact.vue?vue&type=template&id=fc119afe&scoped=true&"
import script from "./NewBusinessContact.vue?vue&type=script&lang=js&"
export * from "./NewBusinessContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc119afe",
  null
  
)

export default component.exports